import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="relative">
      {/* 运营顶条 */}
      <div className="bg-primary-500 text-background-50">
        <div className="mx-auto flex h-9 w-full max-w-7xl items-center justify-between px-4 text-xs md:px-6">
          <p className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-fire-line text-sm" aria-hidden="true" />
            <span className="hidden sm:inline">福利岛今日更新</span>
            <span className="sm:hidden">今日更新</span>
            <span className="bg-background-50/20 px-1.5 py-0.5 rounded">新内容速递上线</span>
          </p>
          <div className="flex items-center gap-4">
            <a href="#talk" className="hover:underline whitespace-nowrap">社区热聊</a>
            <a href="#collection" className="hidden md:inline hover:underline whitespace-nowrap">最新合集</a>
            <span className="flex items-center gap-1 whitespace-nowrap"><i className="ri-time-line" aria-hidden="true" />每日 09:00 更</span>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`sticky top-0 z-40 w-full transition-colors duration-300 ${
          scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-background-50"
        }`}
      >
        <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-gift-2-fill text-lg" aria-hidden="true" />
            </span>
            <span className="font-brand text-2xl leading-none">福利岛</span>
          </a>

          {/* 桌面导航 */}
          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 rounded-md hover:bg-background-100 whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              className="grid h-9 w-9 place-items-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg" aria-hidden="true" />
            </button>
            <a
              href="#cta"
              className="hidden sm:inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors"
            >
              加入追更
              <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
            </a>
            {/* 移动端菜单按钮 */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="grid h-9 w-9 place-items-center rounded-md hover:bg-background-100 cursor-pointer md:hidden"
              aria-label="菜单"
            >
              <i className={`ri-${open ? "close" : "menu"}-line text-xl`} aria-hidden="true" />
            </button>
          </div>
        </nav>

        {/* 移动端展开 */}
        {open && (
          <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
            <div className="flex flex-col">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-2.5 text-sm text-foreground-800 border-b border-background-100 last:border-0"
                >
                  {l.label}
                </a>
              ))}
              <a href="#cta" onClick={() => setOpen(false)} className="mt-3 inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm text-background-50">
                加入追更
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}